import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// layouts 
import AppLayout from '../../../layouts/AppLayout/AppLayout';

// components
import { NioCard, NioSection, NioBadge, NioButton, NioIcon, NioMedia, NioSubscribeField } from '../../../components';

import BASE_URL from '../../../utils/apiConfig';

function Index() {
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [authToken, setAuthToken] = useState(null);

    // Authenticate and retrieve the token
    const authenticateUser = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/api_login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: 'api@gmail.com',
                    password: '123',
                }),
            });

            const data = await response.json();
            if (response.ok) {
                setAuthToken(data.access_token);
            } else {
                console.error('Authentication failed:', data.message);
            }
        } catch (error) {
            console.error('Error during authentication:', error);
        }
    };

    // Fetch subscription plans from the API
    const fetchPlans = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/plans`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            const data = await response.json();
            if (response.ok) {
              if (Array.isArray(data.data)) {
                setPlans(data.data); // Set plans if the data is an array
              } else {
                console.error('Plans data is not an array');
              }
            } else {
                console.error('Failed to fetch plans:', data.message);
                toast.error(`Failed to fetch plans: ${data.message}`);
            }
        } catch (error) {
            console.error('Error fetching plans:', error);
            toast.error('An error occurred while fetching subscription plans.');
        } finally {
            setIsLoading(false);
        }
    };

    // UseEffect to handle authentication and data fetching
    useEffect(() => {
        const initialize = async () => {
            await authenticateUser();
        };
        initialize();
    }, []);

    useEffect(() => {
        if (authToken) {
            fetchPlans();
        }
    }, [authToken]);

  return (
    <AppLayout title="Pricing">

      {/*  Pricing Section Start  */}
      <NioSection className="pt-120 pt-lg-160">
        <div>
          {/* <NioSection.Head alignX="center">
            <span className="nl-section-subtitle mb-2" >Pricing &amp; Plans</span>
            <h2 className="nl-section-title">Choose The Perfect Plan</h2>
            <p className="mb-0" >Discover the ideal plan that suits your needs and unlocks all the features and benefits we offer.</p>
            <ul className="d-flex align-items-center gap-3 flex-wrap justify-content-center pt-5">
              <li>
                <NioButton href="/features" className="btn-primary" label="Explore All Features" />
              </li>
              <li>
                <NioButton href="/contact-us" className="btn-outline-primary" label="Contact Support" />
              </li>
            </ul>
          </NioSection.Head> */}
          {/* <Row className="justify-content-center">
                    <Col lg="10" xl="9"  xxl="8">
                      <div className="nl-section-head text-center">
                      <span className="nl-section-subtitle mb-2">Pricing &amp; Plans</span>
                      <h2 className="nl-section-title">Why Choose ZiloChat?</h2>
                      <p className="mb-0"> 24/7 Availability: ZiloChat keeps WhatsApp active at all times, responding to messages whenever you receive them. </p>
                      <ul className="d-flex gap-3 flex-wrap align-items-center justify-content-center pt-5">
                        <li>
                          <NioButton href="/pricing" className="btn-primary" label="Get Started" />
                        </li>
                        
                      </ul>
                      </div>                                    
                    </Col>
                </Row> */}
                <Row className="justify-content-center">
  <Col lg="10" xl="9" xxl="8">
    <div className="nl-section-head text-center">
      <span className="nl-section-subtitle mb-2">Pricing &amp; Plans</span>
      {/* Make the title smaller */}
      <h4 
        className="nl-section-title" 
        style={{ fontSize: "1.5rem" }} // adjust to desired size
      >
        Onboarding &amp; Training – Free of Charge – Rs. 0
      </h4>

      {/* Center the list as well */}
      <ul 
        className="list-unstyled text-center mx-auto" 
        style={{ maxWidth: "600px" }}
      >
        <li className="mb-2">✔ Personalized onboarding for a smooth start</li>
        <li className="mb-2">✔ AI trained specifically for your business</li>
        <li className="mb-2">✔ Hands-on training for your team</li>
        <li className="mb-2">✔ Optimized workflows for seamless operations</li>
        <li className="mb-2">✔ Technical support to ensure a hassle-free experience</li>
        <li className="mb-2">✔ Performance fine-tuning for maximum efficiency</li>
        <li className="mb-2">✔ Ongoing technical support</li>
      </ul>

      <p className="mt-4 h5">🚀 Limited-Time Offer!</p>

      {/* <ul className="d-flex gap-3 flex-wrap align-items-center justify-content-center pt-5">
        <li>
          <NioButton href="/pricing" className="btn-primary" label="Get Started" />
        </li>
      </ul> */}
    </div>
  </Col>
</Row>

          {/* <NioSection.Content>
            <Row className="gy-5">
              {plans.map((plan) => (
                <Col
                  md="6"
                  lg={{ span: 4, order: plan.id }} // Adjust the order dynamically
                  key={plan.id}
                >
                  <div
                    className={`nl-pricing nl-pricing-s3 mb-5 border p-5 h-100 ${
                      plan.id === 2 ? "border-primary active" : "border-lighter"
                    }`}
                  >
                    <div className="nl-pricing-head mb-3 mb-md-4">
                      <div className="nl-pricing-title-group mb-2">
                        <h4 className="mb-0">{plan.product_name}</h4>
                        {plan.id === 2 && (
                          <NioBadge
                            rounded
                            size="md"
                            label="Popular"
                            icon="star-fill"
                            className="text-bg-white text-primary"
                          />
                        )}
                      </div>
                      <p className="fs-6">{plan.description}</p>
                    </div>

                    <div className="nl-pricing-body">
                      <ul className="nl-list-link">
                        <li className={plan.des_1 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-6">{plan.des_1 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_2 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-6">{plan.des_2 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_3 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-6">{plan.des_3 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_4 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-6">{plan.des_4 || "Feature not available"}</span>
                        </li>
                      </ul>
                      <div className="nl-month-amount amount-wrap pt-4 mt-auto">
                        <span className="amount h3 mb-0">
                          {plan.currency_symbol}
                          {plan.selling_price}
                        </span>
                        <span className="amount-text opacity-75">/user</span>
                      </div>

                      <div className="pt-4">
                        <NioButton
                          href={`/auth/sign-up?referral=${plan.id}`}
                          className={`btn-block ${
                            plan.id === 2 ? "btn-primary" : "btn-outline-primary"
                          }`}
                          label={plan.id === 3 ? "Contact Sales" : "Get Started"}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </NioSection.Content> */}
          <NioSection.Content>
            <Row 
              className={`gy-5 ${plans.length === 1 ? "justify-content-center" : ""}`}
            >
              {plans.map((plan) => (
                <Col
                  md="6"
                  lg={{ span: 4, order: plan.id }} // Adjust the order dynamically
                  key={plan.id}
                >
                  <div
                    className={`nl-pricing nl-pricing-s3 mb-5 border p-5 h-100 ${
                      plan.id === 2 ? "border-primary active" : "border-lighter"
                    }`}
                  >
                    <div className="nl-pricing-head mb-3 mb-md-4">
                      <div className="nl-pricing-title-group mb-2">
                        <h4 className="mb-0">{plan.product_name}</h4>
                        {plan.id === 2 && (
                          <NioBadge
                            rounded
                            size="md"
                            label="Popular"
                            icon="star-fill"
                            className="text-bg-white text-primary"
                          />
                        )}
                      </div>
                      <p className="fs-7">{plan.description}</p>
                    </div>

                    <div className="nl-pricing-body">
                      <ul className="nl-list-link">
                        <li className={plan.des_1 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-8">{plan.des_1 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_2 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-8">{plan.des_2 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_3 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-8">{plan.des_3 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_4 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-8">{plan.des_4 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_5 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-8">{plan.des_5 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_6 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-8">{plan.des_6 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_7 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-8">{plan.des_7 || "Feature not available"}</span>
                        </li>
                        <li className={plan.des_8 ? "active" : ""}>
                          <NioIcon name="check-circle-fill me-1" />
                          <span className="fs-8">{plan.des_8 || "Feature not available"}</span>
                        </li>
                      </ul>
                      <div className="nl-month-amount amount-wrap pt-2 mt-auto">
                        <span className="amount h3 mb-0">
                          {plan.currency_symbol}
                          {plan.selling_price}
                        </span>
                        <span className="amount-text opacity-75">/month</span>
                      </div>

                      <div className="pt-4">
                        <NioButton
                          href={`/auth/sign-up?referral=${plan.id}`}
                          className={`btn-block ${
                            plan.id === 2 ? "btn-primary" : "btn-outline-primary"
                          }`}
                          label={plan.id === 3 ? "Contact Sales" : "Get Started"}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </NioSection.Content>


        </div>
      </NioSection>
      {/*  Pricing Section Start  */}

      {/*  Compare-Plans Section Start  */}
      {/* <NioSection className="pt-7 pt-lg-120" masks={["blur-1 right bottom"]}>
        <div>
          <NioSection.Head alignX="center">
            <span className="nl-section-subtitle mb-2">Compare plans</span>
            <h2 className="nl-section-title">Grow Your Early Stage Startup</h2>
            <p>Unlock the full potential of your early-stage startup with our tailored solutions and expert guidance to drive growth and success.</p>
          </NioSection.Head>
          <NioSection.Content>
            <div className="nl-compare table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th className="nl-compare-col lg empty-col"></th>
                    <th className="nl-compare-col empty-col center">
                      <div className="nl-compare-content">
                        <div className="fs-8 text-uppercase fw-semibold text-gray-700 mb-3 ">Startup</div>
                        <div className="amount h3 mb-4">$99</div>
                        <NioButton href="#" className="btn-outline-primary text-nowrap" label=" Get Started" />
                      </div>
                    </th>
                    <th className="nl-compare-col active empty-col center">
                      <div className="nl-compare-content">
                        <div className="fs-8 text-uppercase fw-semibold text-gray-700 mb-3 ">Growth</div>
                        <div className="amount h3 mb-4">$199</div>
                        <NioButton href="#" className="btn-primary text-nowrap" label=" Get Started" />
                      </div>
                    </th>
                    <th className="nl-compare-col empty-col center">
                      <div className="nl-compare-content">
                        <div className="fs-8 text-uppercase fw-semibold text-gray-700 mb-3 ">Enterprise</div>
                        <div className="amount h3 mb-4">$399</div>
                        <NioButton href="#" className="btn-outline-primary text-nowrap" label=" Get Started" />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <h4 >Analytics</h4>
                      </div>
                    </td>
                    <td className="nl-compare-col"></td>
                    <td className="nl-compare-col active"></td>
                    <td className="nl-compare-col"></td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Real-time analytics</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col active center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle-fill" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Individual user analytics</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col active center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle-fill" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Behaviour analytics</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center"></td>
                    <td className="nl-compare-col active center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle-fill" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col empty-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Data Predictions</p>
                      </div>
                    </td>
                    <td className="nl-compare-col empty-col center"></td>
                    <td className="nl-compare-col empty-col active center"></td>
                    <td className="nl-compare-col empty-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <h4 >Reporting</h4>
                      </div>
                    </td>
                    <td className="nl-compare-col"></td>
                    <td className="nl-compare-col active"></td>
                    <td className="nl-compare-col"></td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Daily reports</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col active center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle-fill" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Weekly reports</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center"></td>
                    <td className="nl-compare-col active center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle-fill" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Monthly reports</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center"></td>
                    <td className="nl-compare-col active center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle-fill" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col empty-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Custom reports</p>
                      </div>
                    </td>
                    <td className="nl-compare-col empty-col center"></td>
                    <td className="nl-compare-col empty-col active center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle-fill" className="text-primary fs-4" />
                      </div>
                    </td>
                    <td className="nl-compare-col empty-col center"></td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <h4 >Security &amp; Privacy</h4>
                      </div>
                    </td>
                    <td className="nl-compare-col"></td>
                    <td className="nl-compare-col active"></td>
                    <td className="nl-compare-col"></td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Two-Factor authentication</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center"></td>
                    <td className="nl-compare-col active center"></td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">SAML-based single sign-on SS</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center"></td>
                    <td className="nl-compare-col active center"></td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">Complience</p>
                      </div>
                    </td>
                    <td className="nl-compare-col center"></td>
                    <td className="nl-compare-col active center"></td>
                    <td className="nl-compare-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="nl-compare-col empty-col lg">
                      <div className="nl-compare-content">
                        <p className="fs-6 mb-0 text-nowrap text-gray-700">CCPA complient processing</p>
                      </div>
                    </td>
                    <td className="nl-compare-col empty-col center"></td>
                    <td className="nl-compare-col empty-col active center"></td>
                    <td className="nl-compare-col empty-col center">
                      <div className="nl-compare-content">
                        <NioIcon  name="check-circle" className="text-primary fs-4" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </NioSection.Content>
        </div>
      </NioSection> */}
      {/*  Compare-Plans Section End  */}

      {/*  CTA Section Start  */}
      {/* <NioSection>
        <NioSection.Content>
          <div className="bg-primary-gradient rounded-3  p-5 p-lg-7" >
            <Row className="gy-5 align-items-center">
              <Col lg="8">
                <div className="d-flex flex-column gap-3 flex-lg-row align-items-center">
                  <NioMedia size="xl" rounded="circle" variant="white" icon="chat-fill text-primary" />
                  <div className="text-center text-lg-start">
                    <h3 className="text-white text-capitalize m-0">Need a custom plan?</h3>
                    <p className="fs-7 mb-0 text-white opacity-75">We provide top notch custom solution for businesses to get started.</p>
                  </div>
                </div>
              </Col>
              <Col lg="4" className="text-center text-lg-end">
                <NioButton href="/contact-us" className="btn-white text-dark fw-semiBold" label="Contact Support" />
              </Col>
            </Row>
          </div>
        </NioSection.Content>
      </NioSection> */}
      {/*  CTA Section End  */}

      {/*  Newsletter Section Start  */}
      <NioSection className="pb-lg-0">
        <Row className="justify-content-center justify-content-lg-between align-items-center gx-0 pb-5 border-bottom border-lighter">
          <Col lg="6" xl="4">
            <div className="text-center text-lg-start pb-5 pb-lg-0">
              <h4 className="text-capitalize">Custom Analytics</h4>
              <p className="fs-7">Unlock valuable insights and make decisions with our custom analytics solitions to your business needs.</p>
            </div>
          </Col>
          <Col md="10" lg="6" xl="5">
            <ul className="d-flex align-items-center gap-3 flex-wrap justify-content-center pt-5">
              <li>
                <NioButton href="" className="btn-primary" label="Request A Demo" />
              </li>
              <li>
                <NioButton href="" className="btn-outline-primary" label="See Pricing" />
              </li>
            </ul>
          </Col>
        </Row>
      </NioSection>
      {/*  Newsletter Section End  */}
      
      {/*  Testimonial Section Start  */}
      <NioSection className="nl-testimonial-section">
        <Row className="justify-content-center">
          <Col lg="8" xxl="4">
            <div className="nl-section-head text-center">
              <span className="nl-section-subtitle">Reviews</span>
              <h2 className="nl-section-title">What our customers are saying</h2>
            </div>
          </Col>
        </Row>
        <NioSection.Content>
          <Row className="g-3 g-lg-4">
            <Col lg="4">
              <NioCard className="h-100">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <div>
                    <ul className="d-flex gap-2 align-items-center mb-2">
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                    </ul>
                    <h5 className="mb-3">ZiloChat has streamlined our customer support.</h5>
                    <p className="fs-8 line-clamp-3">
                    We’ve been able to handle customer inquiries faster and more efficiently, directly through WhatsApp. The automation features have saved us so much time while improving response rates.
                    </p>
                  </div>
                  <div>
                    <h6 className="mb-0">Chamath Perera</h6>
                    <span className="small">3 months ago</span>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
            <Col lg="4">
              <NioCard className="h-100">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <div>
                    <ul className="d-flex gap-2 align-items-center mb-2">
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                    </ul>
                    <h5 className="mb-3">Great tool for growing businesses.</h5>
                    <p className="fs-8 line-clamp-3">
                    ZiloChat has made it easy to manage orders and customer interactions in one place. Improvement in reporting features, it’s been a great addition to our workflow.
                    </p>
                  </div>
                  <div>
                    <h6 className="mb-0">Nimali De Silva</h6>
                    <span className="small">3 months ago</span>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
            <Col lg="4">
              <NioCard className="h-100">
                <NioCard.Body className="d-flex flex-column justify-content-between gap-5">
                  <div>
                    <ul className="d-flex gap-2 align-items-center mb-2">
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                      <li>
                        <NioIcon name="star-fill" className="text-warning" />
                      </li>
                    </ul>
                    <h5 className="mb-3">A fantastic solution for small businesses.</h5>
                    <p className="fs-8 line-clamp-3">
                    We’re a local business, and ZiloChat’s automation has helped us manage more leads without adding extra staff. It’s incredibly user-friendly and worth every rupee.
                    </p>
                  </div>
                  <div>
                    <h6 className="mb-0">Kasun Fernando</h6>
                    <span className="small">3 months ago</span>
                  </div>
                </NioCard.Body>
              </NioCard>
            </Col>
          </Row>
          <div className="text-center pt-5 pt-lg-7">
            <NioButton href="" className="btn-outline-primary" label="See All Reviews" />
          </div>
        </NioSection.Content>
      </NioSection>
      {/*  Testimonial Section End  */}
      {/*  Trial Section Start  */}
      <NioSection className="bg-warning">
        <Row className="justify-content-center">
          <Col xl="10">
            <div className="nl-section-head text-center">
              <h2 className="display-3 mb-3" >Go From Chats to Checkout—Start Today!</h2>
              <div className="col-lg-7 mx-auto">
                <p className="fs-5 text-dark ">ZiloChat takes care of the work so you can scale faster, sell smarter, and focus on growing your business. Your next big win starts now.</p>
              </div>
            </div>
          </Col>
        </Row>
        <NioSection.Content>
          <Row className="justify-content-center">
            <Col md="10" lg="8" xl="6">
              <div>
              <div>
                <ul className="d-flex flex-wrap gap-3 gap-3 justify-content-center">
                  <li>
                    <NioButton href="/pricing" className="btn-primary" label="Get Started" />
                  </li>
                  {/* <li>
                    <NioButton href="/features" className="btn-outline-primary" label="Explore All Features" />
                  </li> */}
                </ul>
              </div>
                {/* <div>
                  <form onSubmit={e=>e.preventDefault()}>
                    <Row className="gy-3 gx-3">
                      <Col md="9">
                        <NioField.Input className="mb-4 mb-md-0" placeholder="Enter Your Email" />
                      </Col>
                      <Col md="3">
                        <input type="submit" className="btn btn-danger btn-block h-100" value="Sign Up Free" />
                      </Col>
                    </Row>
                  </form>
                </div> */}
                <ul className="d-flex flex-wrap align-items-center justify-content-around pt-5">
                  <li className="text-dark" >
                    <NioIcon name="check-circle" className="me-1" />
                    <span className="fs-6">24/7/365 Instant Response</span>
                  </li>
                  <li className="text-dark" >
                    <NioIcon name="check-circle" className="me-1" />
                    <span className="fs-6">All-in-One CRM Solution</span>
                  </li>
                  <li className="text-dark" >
                    <NioIcon name="check-circle" className="me-1" />
                    <span className="fs-6">Every Lead Matters</span>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </NioSection.Content>
      </NioSection>
    </AppLayout>
  )
}

export default Index;